'use strict'

define ['./navbar.css', './navbar-homesmart.scss'], () ->
  (RentappService, $state, $rootScope, $document, Landlord) ->
    restrict: "E"
    template: require("./navbar.jade")
    link: (scope, element, attrs) ->
      scope.theme_color = $rootScope.THEME_COLOR
      scope.logo_only = $rootScope.COMPANY_LOGO_ONLY
      scope.company_logo = $rootScope.COMPANY_LOGO_URL != ""
      scope.company_logo_url = $rootScope.COMPANY_LOGO_URL
      scope.company_name = $rootScope.COMPANY_NAME
      scope.switch_dashboard_name = 'Applicant'
      scope.mobile_view = window.innerWidth < 768
      scope.error_states = [
        "root.home.403",
        "root.home.404"
      ]

      if $rootScope.user
        if $rootScope.applicant || !$rootScope.user.landlord
          scope.mobile_dashboard_name = 'Applicant Dashboard'
        else
          scope.mobile_dashboard_name = 'Landlord Dashboard'

      body = angular.element('body')
      
      scope.toggle_mobile_menu = () ->
        scope.mobile_menu_toggled = !scope.mobile_menu_toggled
        if scope.mobile_menu_toggled
          body.addClass('body-no-scroll')
        else
          body.removeClass('body-no-scroll')
        return

      scope.toggle_menu = () ->
        scope.menu_toggled = !scope.menu_toggled

      scope.$watch(() ->
        $state.$current.name
      , (newVal, oldVal) ->
        scope.current_state = $state.$current.name

        if scope.current_state.indexOf("edit") >= 0
          scope.switch_dashboard_name = 'Landlord'

        if scope.current_state.indexOf("applicant_applications") >= 0 ||
           scope.current_state.indexOf("edit") >= 0 ||
           scope.current_state.indexOf("view_application") >= 0 ||
          scope.mobile_dashboard_name = 'Applicant Dashboard'
        else if scope.current_state.indexOf("setting") >= 0
          scope.mobile_dashboard_name = 'Settings'
        else if scope.current_state.indexOf("payments") >=0
          scope.mobile_dashboard_name = 'My Payments'
        else
          scope.mobile_dashboard_name = 'Landlord Dashboard'

        if newVal.indexOf("home") >= 0 or newVal.indexOf("sample") >= 0
          scope.home_link = 'root.home.landing'
        else
          RentappService.getMe()
            .then (user) ->
              if user.landlord
                scope.home_link = 'root.dashboard.forms'
              else
                scope.home_link = 'root.dashboard.applicant_applications'

        if newVal.indexOf("payments") >=0
          scope.active_link = 'payments'
        else if newVal.indexOf("dashboard.notifications") >= 0
          scope.active_link = 'notifications'
        else if newVal.indexOf("settings") >= 0
          scope.active_link = 'settings'
        else
          scope.active_link = 'dashboard'

        if scope.current_state in scope.error_states
          scope.error_page = true
        else
          scope.error_page = false
        
        ## Hide Navbar on mobile view when viewing an application form if the user is not logged on  
        if scope.current_state.indexOf("apply") >= 0 and scope.mobile_view 
          scope.hide_navbar = true
      )

      scope.logout = () ->
        RentappService.logout()
        .then ->
          $state.go "root.home.landing"

      scope.swtich_dashboard = () ->
        if scope.current_state.indexOf("applicant_applications") >= 0 ||
           scope.current_state.indexOf("edit") >= 0 ||
           scope.current_state.indexOf("view_application") >= 0
          $state.go('root.dashboard.forms')
          scope.switch_dashboard_name = 'Applicant'
        else
          $state.go('root.dashboard.applicant_applications')
          scope.switch_dashboard_name = 'Landlord'

      scope.go_home = () ->
        if not scope.home_link
          if scope.current_state.indexOf("dashboard") >= 0
            $state.go('root.dashboard.forms')
          else
            $state.go('root.home.landing')
        else
          $state.go(scope.home_link)

      scope.go_to_dashboard = () ->
        RentappService.getMe()
          .then (user) ->
            if user.landlord
              $state.go "root.dashboard.forms"
            else
              $state.go "root.dashboard.applicant_applications"

      scope.go_to_settings = () ->
        RentappService.getMe()
          .then (user) ->
            if user.landlord
              $state.go "root.dashboard.settings.profile"
            else
              $state.go "root.dashboard.settings.password"

      scope.go_to_payments = () ->
        Landlord.getMe().$promise.then (me) ->
          if me.payments_enabled
            $state.go "root.dashboard.payments.accounts"
            return
          else
            $state.go "root.dashboard.payments.not_enabled"
            return

      $document.bind 'click', (event) ->
        isClickedMenuArea = element.find(event.target).length > 0
        if isClickedMenuArea
          return
        scope.mobile_menu_toggled = false
        scope.menu_toggled = false
        scope.$apply()
        return



// WEBPACK FOOTER //
// ./directives/navbar/navbar.coffee